import React, { useState } from "react";
import "./AssessmentTableStyles.scss";
import { Button, Card, Space } from "antd";
import AssessmentTableModal from "./AssessmentTableModal";

interface PropsType {
  assessmentData: any;
  addAssessment: any;
}

const Styles = {
  body: {
    marginTop: 16,
    display: "flex",
  },
};

const AssessmentTable: React.FC<PropsType> = ({
  assessmentData,
  addAssessment,
}) => {
  const [openTable, setOpenTable] = useState(false);
  const [view, setView] = useState("");

  const handleClick = (viewOption: string) => {
    setView(viewOption);
    setOpenTable(true);
  };

  return (
    <Card className="mb-2 section-input">
      <Space size={16} direction="vertical" style={Styles.body}>
        <Button
          block
          type="primary"
          size="large"
          style={{
            backgroundColor: "#990000",
            borderRadius: "8px",
            border: "none",
            height: 44,
            fontSize: 16,
            fontWeight: 400,
          }}
          onClick={() => handleClick("experiences")}
        >
          Required experiences
        </Button>
        <Button
          block
          type="primary"
          size="large"
          style={{
            backgroundColor: "#2E4A79",
            borderRadius: "8px",
            border: "none",
            height: 44,
            fontSize: 16,
            fontWeight: 400,
          }}
          onClick={() => handleClick("traits")}
        >
          Required traits
        </Button>
      </Space>

      <AssessmentTableModal
        open={openTable}
        setOpen={setOpenTable}
        view={view}
        setView={setView}
        assessment={assessmentData}
        saveAssessment={addAssessment}
      />
    </Card>
  );
};

export default AssessmentTable;
